// Who the "Admin Reset" list may offer. The server wants a LOGIN id, so a row without a linked
// login is never offered (its employee id could be somebody else's login id), and the signed-in
// admin is left out: their own password is changed on the "My Account" tab with the current one.
export function resetTargets(employees, query, myUserId, limit = 50) {
  const q = (query || "").toLowerCase();
  return (employees || [])
    .filter((employee) => employee.user && String(employee.user) !== String(myUserId ?? ""))
    .filter((employee) => {
      if (!q) return true;
      const haystack = `${employee.display_name || ""} ${employee.candidate_name || ""} ${employee.candidate_email || ""} ${employee.user || ""}`.toLowerCase();
      return haystack.includes(q);
    })
    .slice(0, limit);
}
